import { useMutation } from "react-query";

import axios, { AxiosError } from "axios";

import { GEO_MAP_SERVICE_ADDRESS } from "../../../constants/app.constants";

const upscaleMap = async (data: { group: string; play: string }) => {
  const encodedPlay = btoa(data.play);
  const encodedGroup = btoa(data.group);

  const response = await axios.post(
    `${GEO_MAP_SERVICE_ADDRESS}/map-layer/${encodedPlay}/${encodedGroup}/upscale-lsd-map`,
    { play: data.play }
  );
  return response.data;
};

const useUpscaleMap = () => {
  return useMutation<unknown, AxiosError, { group: string; play: string }, unknown>(
    upscaleMap
  );
};

export default useUpscaleMap;
